(function () {
  'use strict';

  if (window.__dhNativePrefetch) return;
  window.__dhNativePrefetch = true;

  var preview = /[?&](preview_theme_id|preview_key|_fd|pb)=/.test(location.search);
  if (preview || (window.Shopify && (Shopify.designMode || Shopify.visualPreview))) return;

  var support = document.createElement('link');
  if (!support.relList || !support.relList.supports || !support.relList.supports('prefetch')) return;

  var seen = Object.create(null), count = 0, pending = null;
  var MAX_PREFETCH = 2;
  var SKIP = /\/(cart|checkout|checkouts|account|accounts|orders|apps|discount|discounts)(\/|\.|$)|\/(kp-account|logout)(\/|$)|\.(json|js)$|[?&](add|discount|view|section_id|sections|preview_theme_id|preview_key)=/i;

  function allowedConnection() {
    var conn = navigator.connection;
    if (document.hidden) return false;
    if (conn && (conn.saveData || /2g|3g/.test(conn.effectiveType || ''))) return false;
    if (navigator.deviceMemory && navigator.deviceMemory < 4) return false;
    if (navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4) return false;
    return true;
  }

  function destination(a) {
    if (!a || !a.getAttribute || a.hasAttribute('download') || a.hasAttribute('data-no-prefetch') || a.hasAttribute('data-no-spa')) return null;
    if (a.target && a.target !== '_self') return null;
    if (/(^|\s)nofollow(\s|$)/i.test(a.getAttribute('rel') || '')) return null;
    try {
      var url = new URL(a.href, location.href);
      if (!/^https?:$/.test(url.protocol) || url.origin !== location.origin || url.username || url.password) return null;
      if (SKIP.test(url.pathname + url.search)) return null;
      if (url.pathname === location.pathname && url.search === location.search) return null;
      url.hash = '';
      return url.href;
    } catch (e) { return null; }
  }

  function prefetch(a) {
    if (!allowedConnection() || count >= MAX_PREFETCH) return;
    var href = destination(a);
    if (!href || seen[href]) return;
    seen[href] = true;
    count++;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    document.head.appendChild(link);
  }

  function anchor(e) { return e.target && e.target.closest ? e.target.closest('a[href]') : null; }
  function cancel() { if (pending !== null) clearTimeout(pending); pending = null; }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var a = anchor(e);
    if (!a || (e.relatedTarget && a.contains(e.relatedTarget))) return;
    cancel();
    pending = setTimeout(function () { pending = null; prefetch(a); }, 150);
  }, { passive: true, capture: true });
  document.addEventListener('pointerout', function (e) {
    var a = anchor(e);
    if (!a || !e.relatedTarget || !a.contains(e.relatedTarget)) cancel();
  }, { passive: true, capture: true });
  document.addEventListener('focusin', function (e) { prefetch(anchor(e)); });
  document.addEventListener('pointerdown', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    cancel();
    prefetch(anchor(e));
  }, { passive: true, capture: true });
  window.addEventListener('pagehide', cancel);
})();
